import EnumHelper from "../../../helpers/EnumHelper";
import CsmGenericSelectField, { ICsmGenericSelectFieldProps } from "./CsmGenericSelectField";

type innerListType = { value: number, presentation: string };
export type ICsmCstFieldProps = Omit<ICsmGenericSelectFieldProps<innerListType, number>, "list" | "labelGetter" | "valueGetter"> & { cstType: Record<number, string> };

function CsmCstField(props: ICsmCstFieldProps) {
    const { cstType: enumType, ...rest } = props;
    return (
        <CsmGenericSelectField
            {...rest}
            list={EnumHelper.getSelectListAsArray<number, number>(enumType, e => enumType[e])}
            labelGetter={(e) => e.presentation}
            valueGetter={(e) => e.value}
        />
    )
}

export default CsmCstField;